import styled from '@emotion/styled';
import { Box, Stack, Typography } from '@mui/material';
import { theme } from 'theme';
import { transientOptions } from 'utils/transientOptions';

interface PackWrapperProps {
  $tagExist: boolean;
  $isCanPurchase: boolean;
}
export const PackageWrapper = styled(Stack, transientOptions)<PackWrapperProps>`
  margin-top: 12px;
  position: relative;
  cursor: pointer;
  padding: 25px 20px 14px 20px;
  border-radius: 24px;
  height: 280px;
  width: 204px;
  align-items: center;
  justify-content: space-between;
  border: ${({ $isCanPurchase, $tagExist }) =>
    $isCanPurchase || $tagExist
      ? `1px solid ${theme.palette.primary.main}`
      : 'none'};
  background: ${({ $tagExist, $isCanPurchase }) =>
    $isCanPurchase || $tagExist
      ? theme.palette.light.shades8
      : theme.palette.background.light};
`;

export const PopularTag = styled(Box)`
  padding: 4px 6px;
  border-radius: 5px;
  color: ${theme.palette.white.light};
  font-size: 11px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  position: absolute;
  top: 0px;
  left: 10px;
  text-transform: capitalize;
  z-index: 1;
  background: ${theme.palette.primary.main};
`;

export const PackageNameWrapper = styled(Stack)`
  & .package-name {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.1px;
    text-align: center;
    color: ${theme.palette.text.secondary};
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    word-break: break-work;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  & .package-description {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.1px;
    text-align: center;
    color: ${theme.palette.light.quaternary};
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    word-break: break-work;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-transform: capitalize;
  }
`;

export const PricingWrapper = styled(Stack)`
  justify-content: center;
  align-items: center;
  & .per-hour {
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.1px;
    text-align: center;
    color: ${theme.palette.light.tertiary} !important;
    opacity: 0.5;
  }
  & .total-hours {
    font-size: 30px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.1px;
    text-align: center;
    display: flex;
  }
  & .text-house {
    font-size: 18px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.1px;
    text-align: center;
  }
`;

export const TextDetail = styled(Typography)`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
  & span {
    font-weight: 600;
  }
`;

export const ButtonWrapper = styled(Stack)`
  gap: 1;
  & button {
    height: 38px;
  }
  & p {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.1px;
    text-align: center;
  }
`;
